import gsap, { Elastic, Power1 } from 'gsap';

import Header from '../layout/Header';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { ScrollItem__Default } from './ScrollItem__Default';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__ItemProjectList from './InfiniteScroll__ItemProjectList';

class ScrollItem__ProjectList extends ScrollItem__Default {
    scroller;
    holder;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.holder = GetBy.class('__holder', this.item)[0];
        this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_X, {
            domResize: this.item,
            appendContainer: this.holder,
            multiplicator: 1,
            itemClass: InfiniteScroll__ItemProjectList
        });

        const projects = GetBy.class('__item', __link);
        Header.setProjectsN(projects.length);

        this.setUpAnimation();

        this._call = () => this.loop();
        this.onShow = () => {
            this.showAnimation();
            gsap.ticker.add(this._call);
            Header.showProjectsN();
        };

        this.onHide = () => {
            gsap.ticker.remove(this._call);
            Header.hideProjectsN();
        };
    }

    setUpAnimation() {
        this._cards = [...GetBy.class('card-project', this.item)];
        gsap.set(this._cards, { opacity: 0, scaleX: .95, scaleY: .95 });
    }

    showAnimation() {
        super.showAnimation();
        this._cards.map((card, i) => {
            gsap.to(card, { opacity: 1, duration: .3, delay: .1 * i, ease: Power1.easeOut });
            gsap.to(card, { scaleX: 1, scaleY: 1, duration: 1.3, delay: .1 * i, ease: Elastic.easeOut.config(1, .4) });
        })
    }

    show() {
        super.show();
        this.scroller.start();
        this.scroller.show();
    }

    hide() {
        super.hide();
        this.scroller.hide();
    }

    loop() {
        this.scroller.loop();
    }

    dispose() {
        super.dispose();
        this.scroller.dispose();
    }

    resize() {
        super.resize();
        this.scroller.resize();
    }
}

Scroll._registerClass('project-list', ScrollItem__ProjectList);
